import React from 'react';

import { IconProps } from './types';
import styles from './../styles/icon.css';

const FolderCheckIcon: React.FC<IconProps> = props => {
  let svgAttrs;
  if (props.fill) {
    svgAttrs = { fill: props.fill };
  } else {
    svgAttrs = { className: styles.iconSvgPath };
  }

  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Stockholm-icons / Files / Folder-check">
        <path
          id="Combined Shape"
          opacity="0.3"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2 19.5C2 20.3284 2.67157 21 3.5 21H20.5C21.3284 21 22 20.3284 22 19.5V8.5C22 7.67157 21.3284 7 20.5 7H10L7.43934 4.43934C7.15804 4.15804 6.7765 4 6.37868 4H3.5C2.67157 4 2 4.67157 2 5.5V19.5Z"
          {...svgAttrs}
        />
        <path
          id="check-path"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.875 16.75C10.6354 16.75 10.3958 16.6542 10.2042 16.4625L8.2875 14.5458C7.90417 14.1625 7.90417 13.5875 8.2875 13.2042C8.67083 12.8208 9.29375 12.8208 9.62917 13.2042L10.875 14.45L14.0375 11.2875C14.4208 10.9042 14.9958 10.9042 15.3792 11.2875C15.7625 11.6708 15.7625 12.2458 15.3792 12.6292L11.5458 16.4625C11.3542 16.6542 11.1146 16.75 10.875 16.75Z"
          {...svgAttrs}
        />
      </g>
    </svg>
  );
};

export default FolderCheckIcon;
